export const DIVISIONS = [
  { id: "div-mua", name: "Dessy Wedding / MUA", short: "MUA", color: "bg-[#FDF2F0] text-[#B8503D] border-[#F8D5D0]" },
  { id: "div-decor", name: "Aesthetic Decoration", short: "DECOR", color: "bg-[#FEF9EE] text-[#A67C1E] border-[#FBE8B8]" },
  { id: "div-photo", name: "Project by Historia / Photography & Videography", short: "PHOTO", color: "bg-[#F0F5F9] text-[#2C5270] border-[#D0E1EE]" },
  { id: "div-attire", name: "Historia Attire", short: "ATTIRE", color: "bg-[#FBF2FB] text-[#703B6A] border-[#F2D2F2]" },
  { id: "div-music", name: "Historia Musical", short: "MUSIC", color: "bg-[#F0F8FC] text-[#21688B] border-[#CDE7F5]" },
  { id: "div-snap", name: "Historia Snap", short: "SNAP", color: "bg-[#FFF4EF] text-[#C44A1E] border-[#FFD9CA]" },
  { id: "div-studio", name: "Historia's Studio", short: "STUDIO", color: "bg-[#F2F7F2] text-[#3D633D] border-[#D0E3D0]" },
  { id: "div-wo", name: "G-KA Wedding Organizer", short: "WO", color: "bg-[#EFF4FA] text-[#1E436B] border-[#C8DBEE]" },
  { id: "div-handcraft", name: "Historia Handcraft", short: "HANDCRAFT", color: "bg-[#F6F0EA] text-[#7A4A20] border-[#EAD9C4]" },
  { id: "div-warawiri", name: "Wara Wiri Entertainment", short: "WARAWIRI", color: "bg-[#EAF6F4] text-[#1F5F5A] border-[#C5E4DF]" },
  { id: "div-effect", name: "Wedding Effect", short: "EFFECT", color: "bg-[#FCECF5] text-[#8A2A6E] border-[#F5CFE4]" },
  { id: "div-adat", name: "Upacara Adat", short: "ADAT", color: "bg-[#FFF7E0] text-[#8B6914] border-[#F0DFA8]" },
];
export const divisionById = (id) => DIVISIONS.find((d) => d.id === id);

export const BOOKING_STATUSES = ["Inquiry", "Tentative", "Confirmed", "Completed", "Cancelled"];
export const SERVICE_STATUSES = ["Not Started", "In Progress", "Waiting Client", "Ready", "Completed"];
export const TASK_PRIORITIES = ["Low", "Normal", "High", "Urgent"];
export const TASK_STATUSES = ["Available", "Claimed", "To Do", "In Progress", "Waiting", "Done"];
export const PAYMENT_TYPES = ["Booking Fee", "DP 1", "DP 2", "Final Payment", "Other"];
export const QUOTATION_STATUSES = ["Draft", "Sent", "Accepted", "Rejected", "Expired"];
export const INVOICE_STATUSES = ["Draft", "Sent", "Partial", "Paid", "Overdue"];
export const PAYABLE_STATUSES = ["Pending", "Approved", "Overdue", "Paid", "Cancelled"];
export const WAGE_STATUSES = ["Pending", "Approved", "Ready", "Paid"];
export const CONTENT_STATUSES = ["Idea", "Planned", "Production", "Editing", "Waiting Approval", "Scheduled", "Published"];
export const INQUIRY_STATUSES = ["New", "Follow-up", "Qualified", "Quotation", "Negotiation", "Accepted", "Lost", "Converted"];
export const INQUIRY_SOURCES = ["WhatsApp", "Instagram", "Website", "Referral", "Bridestory", "Walk-in", "Event", "Other"];
export const INQUIRY_STATUS_LABEL = { New: "Baru", "Follow-up": "Follow-up", Qualified: "Qualified", Quotation: "Penawaran", Negotiation: "Negosiasi", Accepted: "Diterima", Lost: "Lost", Converted: "Konversi" };
export const REPORT_TYPES = { weekly_company: "Mingguan Perusahaan", monthly_company: "Bulanan Perusahaan", weekly_division: "Mingguan Divisi", monthly_division: "Bulanan Divisi" };
export const CONTENT_PLATFORMS = ["Instagram", "TikTok", "YouTube", "Reels", "Stories", "Website", "Other"];
export const CONTENT_TYPES = ["Reels", "Feed Post", "Carousel", "Story", "YouTube", "Behind The Scenes", "Testimonial", "Educational", "Portfolio", "Other"];

// PBH (Project by Historia) — Production Pipeline (v20)
export const PBH_DIVISION_ID = "div-photo";
export const PRODUCTION_STAGES = [
  "Shooting", "Backup", "Selection", "Photo Editing", "Video Editing",
  "Internal Review", "Client Preview", "Revision", "Final Approval",
  "Album Print", "Packaging", "Delivery", "Completed",
];
export const PBH_POSITIONS = [
  "Photographer", "Videographer", "Drone Operator", "Photo Editor", "Video Editor",
  "Colorist", "Assistant Photographer", "Assistant Videographer",
  "Album Designer", "Print Vendor", "Delivery Crew",
];

export const BOOKING_STATUS_LABEL = { Inquiry: "Inquiry", Tentative: "Tentative", Confirmed: "Terkonfirmasi", Completed: "Selesai", Cancelled: "Dibatalkan" };
export const SERVICE_STATUS_LABEL = { "Not Started": "Belum Mulai", "In Progress": "Dalam Proses", "Waiting Client": "Menunggu Client", Ready: "Siap", Completed: "Selesai" };
export const TASK_STATUS_LABEL = { Available: "Tersedia", Claimed: "Diambil", "To Do": "Belum Mulai", "In Progress": "Dikerjakan", Waiting: "Menunggu", Done: "Selesai" };
export const TASK_PRIORITY_LABEL = { Low: "Rendah", Normal: "Normal", High: "Tinggi", Urgent: "Urgent" };
export const PAYMENT_STATUS_LABEL = { Unpaid: "Belum Bayar", Partial: "Sebagian", Paid: "Lunas" };
export const QUOTATION_STATUS_LABEL = { Draft: "Draft", Sent: "Terkirim", Accepted: "Diterima", Rejected: "Ditolak", Expired: "Kadaluarsa" };
export const INVOICE_STATUS_LABEL = { Draft: "Draft", Sent: "Terkirim", Partial: "Sebagian", Paid: "Lunas", Overdue: "Jatuh Tempo" };
export const PAYABLE_STATUS_LABEL = { Pending: "Menunggu", Approved: "Disetujui", Overdue: "Jatuh Tempo", Paid: "Dibayar", Cancelled: "Dibatalkan" };
export const WAGE_STATUS_LABEL = { Pending: "Menunggu", Approved: "Disetujui", Ready: "Siap Dibayar", Paid: "Dibayar" };
export const CONTENT_STATUS_LABEL = { Idea: "Ide", Planned: "Terjadwal", Production: "Produksi", Editing: "Editing", "Waiting Approval": "Menunggu Approval", Scheduled: "Dijadwalkan", Published: "Terbit" };

export const ROLE_LABEL = {
  owner: "Owner / Accounting",
  admin: "Admin",
  general_manager: "General Manager",
  division_manager: "Manager Divisi",
  division_admin: "Admin Divisi",
  division_staff: "Staf Divisi",
  content_creator: "Content Creator",
  finance: "Keuangan (legacy)",
};

export const isMuaAdmin = (user) => user && user.role === "division_admin" && user.division_id === "div-mua";
export const isCentralAdmin = (user) => user && (["owner","admin","general_manager"].includes(user.role) || isMuaAdmin(user));
export const hasFinancialAccess = (user) => user && ["owner","admin","general_manager"].includes(user.role);
export const isManagement = (user) => user && (["owner","admin","general_manager"].includes(user.role) || isMuaAdmin(user));
export const canDelete = (user) => user && ["owner","general_manager"].includes(user.role);
export const canForceDelete = (user) => user && user.role === "owner";
export const isDivisionUser = (user) => user && ["division_manager","division_admin","division_staff","content_creator"].includes(user.role);
export const isContentCreator = (user) => user && user.role === "content_creator";
export const canManageContent = (user) => user && (isManagement(user) || user.role === "content_creator");

export const statusBadge = (status) => {
  const map = {
    Inquiry: "bg-sky-50 text-sky-700 border-sky-200",
    Tentative: "bg-amber-50 text-amber-800 border-amber-200",
    Confirmed: "bg-emerald-50 text-emerald-800 border-emerald-200",
    Completed: "bg-purple-50 text-purple-800 border-purple-200",
    Cancelled: "bg-rose-50 text-rose-700 border-rose-200",
    Unpaid: "bg-rose-50 text-rose-700 border-rose-200",
    Partial: "bg-amber-50 text-amber-800 border-amber-200",
    Paid: "bg-emerald-50 text-emerald-800 border-emerald-200",
    "Not Started": "bg-zinc-100 text-zinc-700 border-zinc-200",
    "In Progress": "bg-sky-50 text-sky-700 border-sky-200",
    "Waiting Client": "bg-amber-50 text-amber-800 border-amber-200",
    Ready: "bg-indigo-50 text-indigo-800 border-indigo-200",
    "To Do": "bg-zinc-100 text-zinc-700 border-zinc-200",
    Available: "bg-[#FEF9EE] text-[#A67C1E] border-[#FBE8B8]",
    Claimed: "bg-sky-50 text-sky-700 border-sky-200",
    Waiting: "bg-amber-50 text-amber-800 border-amber-200",
    Done: "bg-emerald-50 text-emerald-800 border-emerald-200",
    Low: "bg-zinc-100 text-zinc-700 border-zinc-200",
    Normal: "bg-sky-50 text-sky-700 border-sky-200",
    High: "bg-amber-50 text-amber-800 border-amber-200",
    Urgent: "bg-rose-50 text-rose-700 border-rose-200",
    Draft: "bg-zinc-100 text-zinc-700 border-zinc-200",
    Sent: "bg-sky-50 text-sky-700 border-sky-200",
    Accepted: "bg-emerald-50 text-emerald-800 border-emerald-200",
    Rejected: "bg-rose-50 text-rose-700 border-rose-200",
    Expired: "bg-zinc-100 text-zinc-700 border-zinc-200",
    Overdue: "bg-rose-50 text-rose-700 border-rose-200",
    Pending: "bg-zinc-100 text-zinc-700 border-zinc-200",
    Approved: "bg-sky-50 text-sky-700 border-sky-200",
    Idea: "bg-zinc-100 text-zinc-700 border-zinc-200",
    Planned: "bg-sky-50 text-sky-700 border-sky-200",
    Production: "bg-amber-50 text-amber-800 border-amber-200",
    Editing: "bg-purple-50 text-purple-800 border-purple-200",
    "Waiting Approval": "bg-amber-50 text-amber-800 border-amber-200",
    Scheduled: "bg-indigo-50 text-indigo-800 border-indigo-200",
    Published: "bg-emerald-50 text-emerald-800 border-emerald-200",
  };
  return map[status] || "bg-zinc-100 text-zinc-700 border-zinc-200";
};
